// Room Types
export const roomTypesObj = {
  entire_home: 'Entire House',
  private_room: 'Private Room',
  shared_room: 'Shared Room',
  hotel_room: 'Hotel Room',
};
